import Vue from 'vue'
import Router from 'vue-router'
import { cookies } from '@/utils/cookies'
import loginRouterTable from './loginRouterTable'
import allRoutersTable from './allRoutersTable'
import phoneServiceRoutersTable from './phoneServiceRoutersTable'

Vue.use(Router)

const router = new Router({
  routes: [
    ...loginRouterTable,
    ...phoneServiceRoutersTable,
    ...allRoutersTable,
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  /* 進入頁面前，先檢查是否有token
  有token，則放行
  無token，則導引到登入頁面 */
  if (to.name === 'Login' || to.name === 'ServiceLogin') {
    next()
  } else {
    if (cookies.get('user')) {
      next()
    } else {
      if (from.query.from === 'desktop') {
        next({ name: 'ServiceLogin' })
      } else {
        next({ name: 'Login' })
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js